const props = {
    uuid: {
        required: false,
        type: String,
        default: () => null
    },
    /** 
     * Modifying form contact that should be processed when initializing form.
     * 
     * It has to return modified contact.
     */
    onInit: {
        required: false,
        type: Function,
        /**
         * @param {import("@spa/types/api/app/contact").ContactNotPersistedInterface | import("@spa/types/api/app/contact").ContactInterface} contact
         */
        default: contact => contact
    },
    /**
     * Form options.
     */
    options: {
        required: false,
        /** @returns {import("@spa/types/components").ContactFormOptions} */
        default: () => ({})
    }
};

export default props;